import { Timestamp } from "@firebase/firestore"
import { UTCDate } from "@date-fns/utc"

export type TimestampData = {
  _seconds: number
  _nanoseconds: number
}

export type DateLike =
  | UTCDate
  | Date
  | string
  | number
  | Timestamp
  | TimestampData

export const toUtcDate = (dateLike: DateLike): UTCDate => {
  if (dateLike instanceof UTCDate) {
    return dateLike
  }

  if (dateLike instanceof Date) {
    return new UTCDate(dateLike)
  }

  if (typeof dateLike === "string") {
    return new UTCDate(dateLike)
  }

  if (typeof dateLike === "number") {
    return new UTCDate(dateLike)
  }

  if (dateLike instanceof Timestamp) {
    return new UTCDate(dateLike.toDate())
  }

  return new UTCDate(dateLike._seconds * 1000)
}

export const toUtcDateOrNull = (
  dateLike: DateLike | null | undefined,
): UTCDate | null => {
  if (dateLike == null) {
    return null
  }

  return toUtcDate(dateLike)
}

export const toDate = (dateLike: DateLike): Date => {
  if (dateLike instanceof UTCDate) {
    return new Date(dateLike)
  }

  if (dateLike instanceof Date) {
    return new Date(dateLike)
  }

  if (typeof dateLike === "string") {
    return new Date(dateLike)
  }

  if (typeof dateLike === "number") {
    return new Date(dateLike)
  }

  if (dateLike instanceof Timestamp) {
    return dateLike.toDate()
  }

  return new Date(dateLike._seconds * 1000)
}
